import "./styles.css";
import { Link } from "react-router-dom";
import ImgFone from "../../assets/imagens/whatss.png";

const HeaderPage = (props) => {
  function refreshPage() {
    window.location.href = "/";
  }

  function logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_id");
    localStorage.removeItem("table");
    refreshPage();
  }

  const nomeAba = props.nomeOpcao;

  return (
    <header className="header-container">
      <div className="header-left">
        <Link to="/" className="page-title">
          {nomeAba}
        </Link>
      </div>

      <div className="header-right">
        <div className="whatsapp-container">
          <Link
            to="https://wa.me/+5511940580365"
            target="_blank"
            rel="noreferrer"
            className="whatsapp-link"
          >
            <div className="whatsapp-content">
              <img
                src={ImgFone}
                alt="WhatsApp logo"
                className="whatsapp-logo"
              />
              <span className="whatsapp-text">Central Atendimento</span>
            </div>
          </Link>
        </div>

        <Link onClick={logout} to="/" className="logout-button">
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
          <span className="logout-text">Logout</span>
        </Link>
      </div>
    </header>
  );
};

export default HeaderPage;